import styled from 'styled-components';

export const StyledDownloadButton = styled.div`
  background: ${({ theme }) => theme.background};
  border: solid 2px ${({ theme }) => theme.traitBorder}; 
  width: 100%;
  height: ${({ theme }) => theme.avatarSize};
  min-height: ${({ theme }) => theme.avatarSize};
  padding: 12px;
  position: relative;
  transition: linear 0.2s;
  cursor: ${({ $disabled }) => $disabled ? undefined : 'pointer'};
  opacity: ${({ $disabled }) => $disabled ? '0.4' : '1.0'};

  .download-button-corner-icon {
    position: absolute;
    right: 2px;
    bottom: 2px;
    width: ${({ theme }) => theme.smallButtonSize};
    height: ${({ theme }) => theme.smallButtonSize};
    background: ${({ theme }) => theme.baseYellow};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    img {
      width: 16px;
      height: 16px;
      transition: linear 0.2s;
    }
  }

  &:hover {
    border-color: white;
    background: ${({ theme }) => theme.lightBlue};
  
    .download-button-corner-icon {
      background: ${({ theme }) => theme.brightYellow};
      img {
        scale: 1.2;
      }
    }
  }
`;

